module.exports = __webpack_public_path__ + "img/four4Orange.ff49e22f.png";